import { ConfigProvider } from 'antd';
import { PropsWithChildren } from 'react';

import '../style/global.scss';

import { themeColors } from './config/colors';
import { ThemeSlug } from './config/common';
import { themeFonts } from './config/fonts';
import { getComponentsConfig, getTokenConfig } from './config/utils';
import { ThemeContext } from './context';

export function ThemeProvider({
  children,
  theme: themeSlug = 'next',
  localize,
}: PropsWithChildren<{
  theme?: ThemeSlug;
  localize?: (value: string) => string;
}>) {
  const colors = themeColors[themeSlug];
  const fonts = themeFonts[themeSlug];
  const theme = {
    colors,
    fonts,
  };

  return (
    <ThemeContext.Provider value={{ colors, fonts, localize }}>
      <ConfigProvider
        theme={{
          token: getTokenConfig(theme),
          components: getComponentsConfig(theme),
        }}
      >
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
}
